import { ApiService, ApiServiceInterface } from "../../../../../core";
import { SubscriptionStatementDataResponse, SubscriptionStatementUnsubscribeResponse } from "../../../site/interfaces";
import { SubscriptionStatementPageController } from "../../core";

export class SubscriptionStatementPageControllerImpl implements SubscriptionStatementPageController {
    private api: ApiServiceInterface;

    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<SubscriptionStatementDataResponse> {
        try {
            const response = await this.api.get('/subscriptions-user');
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    async showBankSlip(id: string): Promise<SubscriptionStatementDataResponse> {
        try {
            const response = await this.api.get(`/subscription-user-bank-slip/${id}`);
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    async updateSubscription(status: string, id: string): Promise<SubscriptionStatementDataResponse> {
        try {
            const requestData = {};
            requestData['id'] = id;
            requestData['status'] = status;

            const response = await this.api.put(`/payment-update-status`, requestData);
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    async cancelSubscription(id: string, reason: string): Promise<SubscriptionStatementUnsubscribeResponse> {
        try {
            const requestData = {};
            requestData['id'] = id;
            requestData['reason'] = reason;

            const response = await this.api.put(`/unsubscribe`, requestData);
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }
}